import { Component, Signal, viewChild } from '@angular/core';
import { MatTabNav } from '@angular/material/tabs';

@Component({
    selector: 'app-dictionaries',
    templateUrl: './dictionaries.component.html',
    styleUrls: ['./dictionaries.component.scss'],
    standalone: false
})
export class DictionariesComponent {
  private static readonly PAGE_TO_TABS_DELAY_MS: number = 150;
  private static readonly TABS_TO_PAGE_DELAY_MS: number = 600;

  private readonly tabNavBar: Signal<MatTabNav | undefined> = viewChild(MatTabNav);
  private hasScrolledTabsSincePointerEntered: boolean = false;
  private tabPointerEnteredAtMs: number | null = null;
  private tabBoundaryReachedAtMs: number | null = null;

  navigationLinks = [
    {
      label: 'common notes',
      path: '/piping/dictionaries/commonnotes',
      index: 0
    },
    {
      label: 'services',
      path: '/piping/dictionaries/services',
      index: 1
    },
    {
      label: 'service details',
      path: '/piping/dictionaries/servicedetails',
      index: 2
    },
    {
      label: 'pressure and temp tables',
      path: '/piping/dictionaries/pressureandtemperature',
      index: 3
    },
    {
      label: 'branch tables',
      path: '/piping/dictionaries/branch',
      index: 4
    },
    {
      label: 'branch table codes',
      path: '/piping/dictionaries/branchTableCodes',
      index: 5
    },
    {
      label: 'component catalog',
      path: '/piping/dictionaries/componentcatalog',
      index: 6
    },
    {
      label: 'component properties',
      path: '/piping/dictionaries/componentproperties',
      index: 7
    },
    {
      label: 'valve properties',
      path: '/piping/dictionaries/valveproperties',
      index: 8
    },
    {
      label: 'applications',
      path: '/piping/dictionaries/applications',
      index: 9
    },
    {
      label: 'business units',
      path: '/piping/dictionaries/businessunits',
      index: 10
    },
    {
      label: 'specifications',
      path: '/piping/dictionaries/specifications',
      index: 11
    },
    {
      label: 'pipe class properties',
      path: '/piping/dictionaries/pipeclassproperties',
      index: 12
    }
  ];
  activeLink = this.navigationLinks[0].path;

  startTabScrollSession(): void {
    this.tabPointerEnteredAtMs = performance.now();
    this.hasScrolledTabsSincePointerEntered = false;
    this.tabBoundaryReachedAtMs = null;
  }

  scrollTabs(event: WheelEvent): void {
    const tabNavBar: MatTabNav | undefined = this.tabNavBar();
    if (!tabNavBar) {
      return;
    }

    const currentTimeMs: number = performance.now();
    this.tabPointerEnteredAtMs ??= currentTimeMs;
    if (currentTimeMs - this.tabPointerEnteredAtMs < DictionariesComponent.PAGE_TO_TABS_DELAY_MS) {
      return;
    }

    const wheelDelta: number = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
    const previousDistance: number = tabNavBar.scrollDistance;
    tabNavBar.scrollDistance = previousDistance + wheelDelta;

    if (tabNavBar.scrollDistance !== previousDistance) {
      this.hasScrolledTabsSincePointerEntered = true;
      this.tabBoundaryReachedAtMs = null;
      event.preventDefault();
      return;
    }

    if (!this.hasScrolledTabsSincePointerEntered) {
      return;
    }

    this.tabBoundaryReachedAtMs ??= currentTimeMs;
    if (currentTimeMs - this.tabBoundaryReachedAtMs < DictionariesComponent.TABS_TO_PAGE_DELAY_MS) {
      event.preventDefault();
    }
  }

  endTabScrollSession(): void {
    this.hasScrolledTabsSincePointerEntered = false;
    this.tabPointerEnteredAtMs = null;
    this.tabBoundaryReachedAtMs = null;
  }
}
